
import { Component, ActionButtonConfig, FormModalMixins } from "@/lib";
import Sender from "@/store/modules/system/sender/entity";
@Component
export default class CreateSender extends FormModalMixins {
  model = new Sender();
  created() {
    Object.assign(this.config, { modelTitleL: "Action.Add", labelWidth: 120, okAction: "system/sender/create" });
  }
  validateFeild(field) {
    (this.$refs["form-modal"] as any).validateField(field);
  }
  close() {
    this.config.isShow = false;
    this.model = new Sender();
  }
}
